import React from 'react';

const YesNoFmt = ({ children }) => {

    try {

        if(children){
            return(<span>Yes</span>);
        } else {
            return(<span>No</span>);
        }

    } catch (error) {
        console.error(error);
        return <span>Invalid boolean</span>;
    }

};

export default YesNoFmt;